import { SSEService } from '@/shared/services/sse';

export const SSETalkSmsChannel = SSEService.createEventChannel('talk.sms');
export const SSETalkFaxChannel = SSEService.createEventChannel('talk.fax');
export const SSETalkEndpointChannel = SSEService.createEventChannel('talk.endpoint');
export const SSETalkEndpointRegisterChannel = SSEService.createEventChannel('talk.endpoint.register');
export const SSETalkAccessChannel = SSEService.createEventChannel('talk.access');
